// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background-color: var(--primary-text);
  color: var(--bg-color);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
  position: relative;
  max-width: 80%;
}

.x-button {
  color: var(--bg-color);
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 5px;
}

.modal-image {
  color: var(--primary-color);
  padding: 20px;
}

.modal-content {
  color: var(--bg-color);
}

.modal-header {
  font-size: 30px;
  font-weight: var(--roboto-bold);
  padding: 10px;
}

.modal-header + p {
  font-size: 1.2rem;
  font-weight: var(--roboto-regular);
  padding: 10px;
}

.close-button {
  background-color: var(--primary-color);
  text-align: center;
  text-decoration: none;
  border: 2px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-weight: var(--roboto-bold);
  color: var(--bg-color);
  font-size: 20px;
  width: 40%;
  height: 50px;
  min-width: 70px;
  margin-top: 10px;
}

.close-button:hover {
  background-color: var(--secondary-color);
  color: var(--primary-text);
}

.x-button:hover {
  color: var(--primary-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/Modal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.9);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.modal {\r\n  background-color: var(--primary-text);\r\n  color: var(--bg-color);\r\n  padding: 20px;\r\n  border-radius: 10px;\r\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);\r\n  position: relative;\r\n  max-width: 80%;\r\n}\r\n\r\n.x-button {\r\n  color: var(--bg-color);\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  padding: 5px;\r\n}\r\n\r\n.modal-image {\r\n  color: var(--primary-color);\r\n  padding: 20px;\r\n}\r\n\r\n.modal-content {\r\n  color: var(--bg-color);\r\n}\r\n\r\n.modal-header {\r\n  font-size: 30px;\r\n  font-weight: var(--roboto-bold);\r\n  padding: 10px;\r\n}\r\n\r\n.modal-header + p {\r\n  font-size: 1.2rem;\r\n  font-weight: var(--roboto-regular);\r\n  padding: 10px;\r\n}\r\n\r\n.close-button {\r\n  background-color: var(--primary-color);\r\n  text-align: center;\r\n  text-decoration: none;\r\n  border: 2px solid transparent;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: var(--roboto-bold);\r\n  color: var(--bg-color);\r\n  font-size: 20px;\r\n  width: 40%;\r\n  height: 50px;\r\n  min-width: 70px;\r\n  margin-top: 10px;\r\n}\r\n\r\n.close-button:hover {\r\n  background-color: var(--secondary-color);\r\n  color: var(--primary-text);\r\n}\r\n\r\n.x-button:hover {\r\n  color: var(--primary-color);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
